import { DadosErpDoFornecedor } from '../protocols';

export const checkInvalidCapa = (obj: DadosErpDoFornecedor): boolean => {
  return Object.values(obj).some((value) => value.invalid === true);
};
